import Vue                  from 'vue';
import Router               from 'vue-router';

import constants            from '@/constants';

// Views
import Main                 from '@/views/Main.vue';
// import Admin                from '@/views/Admin.vue';

// Components inserted by router / routes
import DetailModal          from '@/components/detail/DetailModal.vue';
import MapTrayMiniDetail    from '@/components/map/MapTrayMiniDetail.vue';
import MapTraySearchResults from '@/components/map/MapTraySearchResults.vue';

import HomeTrayContent      from '@/components/HomeTrayContent.vue';

import StyleGuideModal      from '@/components/StyleGuideModal.vue';
import NotFoundModal        from '@/components/NotFoundModal.vue';

import OrientationModal     from '@/components/OrientationModal.vue';
import TestTypes            from '@/components/test/TestTypes.vue';

Vue.use(Router);

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: constants.RouteNames.Main,
      component: Main,

      // TODO: This is all fucked up.
      //
      // The child route acts as a go-between to expose a
      // router-view instance that the grandchild route uses.
      //
      // And, the child route does nothing except run some code,
      // indirectly, in Stations.vue, on its $watcher and .beforeRouteEnter
      children: [
        // OLD WAY:
        // {
        //   path: '/station/:siteNumber',
        //   component: StationGraphModal,
        //   name: 'StationGraphModal',
        //   props: true

        //   // TODO: Need to set something in Vuex here... that's the right
        //   //       way to do this.
        // },
        {
          path: '/',
          component: HomeTrayContent,
        },
        {
          path: '/search/:query',
          component: MapTraySearchResults,
          name: constants.RouteNames.Search,
          // props: true,
        }, {
          path: '/sites/:state/:siteNumber',
          component: MapTrayMiniDetail,
          name: constants.RouteNames.MiniDetail,
          props: true,

          // // Ok, this is weird.

          // // Basically all the logic to cover this route is in Main.vue's watcher
          // // for $route. Huh.
          children: [
            {
              path: 'detail',
              name: 'DetailModal',
              component: DetailModal,
              props: true
            },
          ]
        }, {
          path: '/near',
          name: constants.RouteNames.NearLocation,
          component: MapTraySearchResults
          // props: true,
        },
      ],
    },

    // TODO QUINN: Uncomment this to launch orientation modal
    // {
    //   path: '/orientation',
    //   component: OrientationModal
    // },

  // {
  //   path: '/style-guide',
  //   component: StyleGuideModal
  // },

    {
      path: '/test',
      component: TestTypes
    },

    {
      path: '/:pathMatch(.*)*',
      component: NotFoundModal
    },
  ]
});

declare global {
  interface Window {
      gtag: Function;
      GA_TRACKING_ID: String;
  }
}

router.afterEach((to) => {
  if (window.hasOwnProperty('GA_TRACKING_ID')) {
    window.gtag('config', window.GA_TRACKING_ID, {
      page_path: to.fullPath,
      send_page_view: true,
    });
  }
});

export default router;
